import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router'

import { resourceTypes } from '../constants'
import { type ResourceTypes } from '../types'

const buildChildRoute = (resourceType: ResourceTypes): RouteRecordRaw => ({
  children: [
    {
      component: async () => import('../views/MenuNewView.vue'),
      name: `brand.menu.${resourceType}.new`,
      path: 'new',
      props: () => ({
        resourceId: undefined,
        resourceType,
      }),
    },
    {
      component: async () => import('../views/MenuDetailView.vue'),
      name: `brand.menu.${resourceType}.detail`,
      path: ':resourceId',
      props: (route: RouteLocationNormalized) => ({
        resourceId: route.params.resourceId,
        resourceType,
      }),
    },
  ],
  component: async () => import('../views/MenuMainView.vue'),
  name: `brand.menu.${resourceType}`,
  path: resourceType,
  props: () => ({
    resourceType,
  }),
})

export const menuRouter = [
  {
    children: resourceTypes
      .filter((resourceType) => resourceType !== 'coupon')
      .map((resourceType) => buildChildRoute(resourceType)),
    component: {
      template: '<router-view />',
    },
    meta: {
      title: 'restaurant.menu',
    },
    name: 'brand.menu',
    path: 'menu',
    redirect: { name: 'brand.menu.menu' },
  },
  {
    ...buildChildRoute('coupon'),
    meta: {
      title: 'restaurant.coupons',
    },
    name: 'brand.coupon',
    path: 'coupon',
  },
]
